/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_Version_DesktopInputs */

const en_pc_online_cmp_version_desktop = /** @type {(inputs: Pc_Online_Cmp_Version_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any release you install`)
};

const zh_pc_online_cmp_version_desktop = /** @type {(inputs: Pc_Online_Cmp_Version_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你安装的任意版本`)
};

/**
* | output |
* | --- |
* | "Any release you install" |
*
* @param {Pc_Online_Cmp_Version_DesktopInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_version_desktop = /** @type {((inputs?: Pc_Online_Cmp_Version_DesktopInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_Version_DesktopInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_version_desktop(inputs)
	return zh_pc_online_cmp_version_desktop(inputs)
});
export { pc_online_cmp_version_desktop as "pc.online.cmp.version.desktop" }